<template>
  <ux-form
    ref="form"
    :data="formData"
    width="600px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="renewal"
  >
    <ux-form-item :label="$t('HT.addLicense.userName')" prop="title">
      <ux-input v-model="formData.title" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.sales')" prop="sales">
      <ux-input v-model="formData.sales" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.engineer')" prop="engineer">
      <ux-input v-model="formData.engineer" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxConn')" prop="max_conn">
      <ux-input v-model="formData.max_conn" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxHosts')" prop="max_hosts">
      <ux-input v-model="formData.max_hosts" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.expireDate')" prop="add_date">
      <ux-radio v-model="formData.add_date" :options="$opt.expire_date"></ux-radio>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.date')" v-if="formData.add_date === 0">
      <ux-date v-model="formData.date" top></ux-date>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          add_date: '', // 有效期
          date: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.renewal()
    };
  }
};
</script>
